<template>
  <div class="guide">
    <h1>{{ artName }}</h1>
  </div>
</template>

<script>
export default {
  name: "GuidePage",
  data() {
    return {
      artName: "123",
    };
  },
  mounted() {
    console.log(111111111111);
    this.artName = this.$route.query.name;
    //   console.log(this.artName,"artNameartNameartName");
    window.location.href = "http://www.shanghaieye.cn";
  },
};
</script>

<style lang="less" scoped></style>
